import { GlEmptyState, GlLoadingIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import emptySearchSvg from '@gitlab/svgs/dist/illustrations/empty-state/empty-search-md.svg';
import { s__ } from '~/locale';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import ErrorsAlert from '../../../../../../../app/assets/javascripts/vue_shared/components/errors_alert.vue?vue3';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import { TYPENAME_AI_CATALOG_MCP_SERVER } from '../constants';
import aiCatalogMcpServerQuery from '../graphql/queries/ai_catalog_mcp_server.query.graphql';
export default {
    name: 'AiCatalogMcpServer',
    components: {
        ErrorsAlert,
        GlEmptyState,
        GlLoadingIcon
    },
    data () {
        return {
            aiCatalogMcpServer: null,
            errors: []
        };
    },
    apollo: {
        aiCatalogMcpServer: {
            query: aiCatalogMcpServerQuery,
            variables () {
                return {
                    id: convertToGraphQLId(TYPENAME_AI_CATALOG_MCP_SERVER, this.$route.params.id)
                };
            },
            update: (data)=>data.aiCatalogMcpServer,
            error (error) {
                this.errors = [
                    s__('AICatalog|Failed to load MCP server')
                ];
                Sentry.captureException(error);
            }
        }
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.aiCatalogMcpServer.loading;
        },
        isNotFound () {
            return !this.isLoading && !this.aiCatalogMcpServer;
        }
    },
    watch: {
        aiCatalogMcpServer: {
            handler () {
                if (this.aiCatalogMcpServer?.name) {
                    document.title = `${this.aiCatalogMcpServer.name} · ${this.baseTitle}`;
                }
            },
            deep: true
        }
    },
    created () {
        const itemType = s__('AICatalog|MCP');
        this.baseTitle = document.title.includes(itemType) ? document.title : `${itemType} · ${document.title}`;
    },
    emptySearchSvg
};
